const DOM = {
    onReady(func) {
        if (document.readyState !== 'loading') {
            return func(new Event('ready'));
        }
        document.addEventListener('DOMContentLoaded', func);
    },
    onLoad(func) {
        if (document.readyState === 'complete') {
            return func();
        }
        window.addEventListener('load', func);
    },
    getChildIndex(parent, child) {
        return Array.from(parent.children).indexOf(child);
    },
    getChildAt(parent, index) {
        return parent.children[index];
    },
    getChildCount(parent) {
        return Array.from(parent.children).length;
    },
};
const Helpers = {
    Screen: {
        isWiderThanBreakpoint(name) {
            return window.innerWidth >= Helpers.Style.getBreakpoint(name);
        },
    },
    Style: {
        getBreakpoint(name) {
            const val = this.getCssVar(`--breakpoint-${name}`).replace('px', '');
            return parseInt(val, 10);
        },
        getCssVar: (varName) => {
            return getComputedStyle(document.documentElement).getPropertyValue(varName);
        },
        setCssVar: (varName, value) => {
            document.documentElement.style.setProperty(varName, value);
        },
    },
};
export { DOM, Helpers };
